export default class EvaluationItemDto {
  itemId;
  listId;
  categoryId;
  itemName;
  outputOrder;
  abolitionFlg;
  stickerId = [];
  stickerFileName = [];

  constructor(data) {
    this.itemId = data.itemId;
    this.listId = data.listId;
    this.categoryId = data.categoryId;
    this.itemName = data.itemName;
    this.outputOrder = data.outputOrder;
    this.abolitionFlg = data.abolitionFlg;
    this.stickerId = data.stickerId;
    this.stickerFileName = data.stickerFile;
  }
}
